import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setZoneActions,
  setZoneDeleteActions,
  getSideBarfilesActions,
  setGeoLoactionStateAction,
  setRegionActions,
  setTablePositionPersist
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import ZoneCreate from "./ZoneCreate";
import Delete from "../../AppComponent/Popup/Delete";
import { NavLink } from "react-router-dom";
import Select from "react-select";
import _ from "lodash";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import useDebouncedEffect from 'use-debounced-effect';


const Zone = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
 const TablePositionPersist = useSelector(state=>state.PreviousPagePosition.TablePositionPersist)

  const UserObjectData = useSelector((state) => state.users.UserData);

  const dispatch = useDispatch();
  const state = useSelector((state) => state);
const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.Overall_ZoneDatas?.page == undefined
      ? 1
      : TablePositionPersist.Overall_ZoneDatas.page
  );
  const [search,setsearch] = useState(
      TablePositionPersist?.Overall_ZoneDatas?.search == undefined ||
      TablePositionPersist?.Overall_ZoneDatas?.search == ""
        ? ''
        : TablePositionPersist?.Overall_ZoneDatas?.search
    ); 
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [Data, setdatas] = useState([]);
  const [newpages, setNewpage] = useState(1);
  const [createzone, setZonecreate] = useState(false);
  const [DeleteID, setDeleteID] = useState("");
  const [DeletePOPUP, setDeletePOPUP] = useState(false);
  const [EditId, setEditId] = useState();
  const [multiselect, setMuliselect] = useState([
    //  { value: "", label: "All" }
    state.ClientBranchIDs.StateName,
  ]);
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState([]);
  const [multiselect3, setMuliselect3] = useState([]);
  const [nameList4, setOptions4] = useState([]);
  const [data, setData] = useState({ zone: "",     state: state.ClientBranchIDs.StateName.value,
 region: "" });
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);

  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);



  useEffect(() => {
    const payloads = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      counts: 3,
      state: data.state,
      region: data.region,
    };
    dispatch(setZoneActions(payloads));
    // console.log(state.ZonePart.Zone, "states", state.ZonePart.Total_count);
    setdatas(state.ZonePart.Zone);
       dispatch(
                  setTablePositionPersist({ data: payloads, pageName: "Overall_ZoneDatas" })
                );
        
  }, [dtpageindex, data]);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);

  useEffect(() => {
    const Datas = [];

    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];

    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  useDebouncedEffect(
    () => {
        if (setSearchDebounance) {
            setSearched({
                ...SearchedVal,
                stateSearch: SearchDebounance.stateSearch,
                regionSearch: SearchDebounance.regionSearch,
            });
        }
    },
    500,
    [SearchDebounance]
);

  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,

    });

};

///---Region-----------------
const handleInputRegion = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        regionSearch: Val,
    });
};
  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);

  const handleSelectChange = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect3({ value: "search", label: "Search" });
      setMuliselect1({ value: "search", label: "Search" });

      console.log(selectedVal, "asfad");
      setData({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setMuliselect({ value: "search", label: "Search" });

      setMuliselect1({ value: "search", label: "Search" });
      setMuliselect3({ value: "search", label: "Search" });
      setData({
        ...data,
        state: "",
        region: "",
        zone: "",
      });
    }
  };

  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setData({
        ...data,
        region: selectedVal.value,
        zone: "",

      });
    }
    if (selectedVal == null && data.state == null && data.zone == null) {
      setData({
        ...data,
        region: "",
        zone: "",

      });
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...data,
        region: "",
        zone: "",
      });
    }
  };

  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        const payload = {
          search: e,
          page_size: dtpagesize,
          page: 1,
          counts: 3,
          state: data.state,
          region: data.region,
        };
        // console.log(e, "testnew")
        dispatch(setZoneActions(payload));
      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    console.log("ee", e);
    setsearch(e);
    debouncedSearch(e);

  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handlePageChange = (newPage) => {
    if (newPage < state.ZonePart.Total_count) {
      setCurrentPage(newpages + 1);
      setNewpage(newPage + 1);
      const pageEntries = {
        search: search,
        page_size: 10,
        page: newPage,
        counts: 3,
        state: data.state,
        region: data.region,
      };
      dispatch(setZoneActions(pageEntries));
      console.log("New Page:", newpages);
    }
  };
  const HandelDelete = () => {
    if (DeleteID != undefined) {
      console.log(currentPage, "sdsd");
      const payload = {
        DeleteID: DeleteID,
        currentPage: currentPage,
        counts: 3,
        state: data.state,
        region: data.region,
      };
      dispatch(setZoneDeleteActions(payload, setDeletePOPUP(false)));
    }
  };
  const columns = [
    {
      Header: "Zone",
      accessor: "zone_name",
    },
    {
      Header: "Description",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>
              {row.row.original.description != null &&
              row.row.original.description != "" ? (
                <span>{row.row.original.description}</span>
              ) : (
                <span>{"---"} </span>
              )}
            </span>
          </>
        );
      },
    },
    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },
    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                onClick={(e) => {
                  setEditId(row.row.original.id);
                  setZonecreate(true);
                }}
                component="span"
              >
                <span className="OuterActionSpan">
                <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>

              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  setDeleteID(row.row.original.id);
                  setDeletePOPUP(true);
                }}
              >
                <span className="OuterActionSpan">
                <span  className="EditImages">
                    <img src={DeleteImages}/>
                  </span>

                  <span className="ActionsList"> Delete </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Zone</h3>
          </div>
          <div className="Add-User col-sm-5">
            <button
              onClick={(e) => {
                setZonecreate(true);
                setEditId("");
              }}
              className="ButtonCSS"
            >
              {" "}
              Create{" "}
            </button>
          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               

            marginLeft: "0px",
            marginRight: "0px",
          }}
        >
          <div className="col">
            <label for="validationCustom01" class="form-label">
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                setdtPageindex(1);
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              value={multiselect}
            />
          </div>

          <div className="col">
            <label for="validationCustom01" class="form-label">
              Region 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                setdtPageindex(1);
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              value={multiselect1}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              onInputChange={handleInputRegion}
            />
          </div>
        </div>

        {Data != undefined ? (
          <div style={{ padding: " 0px 40px" }}>
            <ReactTable
              data={state.ZonePart.Zone}
              columns={columns}
              totalItems={state.ZonePart.Total_count}
              currentPage={currentPage}
              onChange={tochange}
              setCurrentPage={setCurrentPage}
              pagesize={pagesize}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
              dtpagesize={pageSize}
              dtpageindex={dtpageindex}
              pageindex={pageindex}
              datacount={state.ZonePart.Total_count}
              Oncreate={(e) => {
                setZonecreate(true);
                setEditId("");
              }}
              Filter={true}
              NoFilter ={true}
  
                                   searchVal={TablePositionPersist?.Overall_ZoneDatas?.search == "" || TablePositionPersist?.Overall_ZoneDatas?.search ==undefined? "":TablePositionPersist.Overall_ZoneDatas.search}
              search_key={true}

            />
          </div>
        ) : null}
      </div>
      {EditId != undefined && createzone ? (
        <ZoneCreate
          show={createzone}
          setShow={setZonecreate}
          currentPage={dtpageindex}
          EditId={EditId}
          stateID={data.state}
          regionID={data.region}
          search={search}
        />
      ) : null}

      {DeletePOPUP ? (
        <Delete
          show={DeletePOPUP}
          setShow={setDeletePOPUP}
          onSubmit={HandelDelete}
          Content={"Do you want to delete the Zone"}

        />
      ) : null}
    </>
  );
};

export default Zone;
